export default {
  title: {
    base: 'by clicking on the following button',
    keyword: 'Sign up now in 2 min',
  },
  buttons: {
    account: 'Create an account',
  },
  form: {
    title: 'Or fill in the following form to schedule a demo call:',
    inputs: {
      first_name: 'First name',
      last_name: 'Last name',
      email: 'Email',
      contact_number: 'Contact number',
      clinic_name: 'Private clinic name',
      source: 'How did you hear about us?',
      reference: 'Referred by (if applicable):',
    },
    buttons: {
      submit: {
        default: 'Submit',
        done: 'Submitted',
      },
    },
  },
};
